/**
 * @generated SignedSource<<721d5351e4f7afaa6d869b2a48fa87aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FollowType = "Author" | "Section" | "Topic" | "%future added value";
export type hooksFetchUserServiceQuery$variables = Record<PropertyKey, never>;
export type hooksFetchUserServiceQuery$data = {
  readonly bookmarks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: number;
        readonly targetEntityId: string;
      };
    }>;
  };
  readonly follows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly targetEntityId: string;
        readonly type: FollowType;
      };
    }>;
  };
};
export type hooksFetchUserServiceQuery = {
  response: hooksFetchUserServiceQuery$data;
  variables: hooksFetchUserServiceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetEntityId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksFetchUserServiceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "BookmarkConnection",
        "kind": "LinkedField",
        "name": "bookmarks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BookmarkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Bookmark",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "bookmarks(first:10000)"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "FollowConnection",
        "kind": "LinkedField",
        "name": "follows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FollowEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Follow",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "follows(first:10000)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksFetchUserServiceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "BookmarkConnection",
        "kind": "LinkedField",
        "name": "bookmarks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BookmarkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Bookmark",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "bookmarks(first:10000)"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "FollowConnection",
        "kind": "LinkedField",
        "name": "follows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FollowEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Follow",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "follows(first:10000)"
      }
    ]
  },
  "params": {
    "cacheID": "356718d84a229f62c46c7f65b487000a",
    "id": null,
    "metadata": {},
    "name": "hooksFetchUserServiceQuery",
    "operationKind": "query",
    "text": "query hooksFetchUserServiceQuery {\n  bookmarks(first: 10000) {\n    edges {\n      node {\n        targetEntityId\n        createdAt\n        id\n      }\n    }\n  }\n  follows(first: 10000) {\n    edges {\n      node {\n        targetEntityId\n        type\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c28cf62ed735c56d7f5a166d2da7711";

export default node;
